export default __webpack_public_path__ + "static/media/InputDrop.4c8bc007.svg";